import type { ReactNode } from "react";

/**
 * The top of every screen. Eyebrow, title, one line of description, and a
 * slot on the right for the actions that belong to the whole page.
 *
 * The description is not decoration: on the queue screens it is where the
 * rule that governs the queue gets stated, and an operator who reads it
 * before acting makes better decisions than one who guesses.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex items-end justify-between gap-5 flex-wrap">
      <div className="min-w-0">
        {eyebrow ? (
          <p className="mb-2 inline-flex rounded-full bg-brand-green px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.15em] text-on-brand">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-[30px] font-bold leading-none tracking-[-0.035em] text-ink sm:text-[34px]">
          {title}
        </h1>
        {description ? (
          <p className="mt-2 max-w-[68ch] text-[12.5px] leading-relaxed text-muted">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex items-center gap-2 shrink-0">{actions}</div>
      ) : null}
    </header>
  );
}
